export const MANAGER_COMMENTS_DE = 'TWq0deNfRvZ';

export const parseManagerComments = (raw) => {
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (err) {
    console.warn('⚠️ managerComments parse failed:', err);
    return [];
  }
};

export const serializeManagerComments = (arr) => {
  return JSON.stringify(Array.isArray(arr) ? arr : []);
};